import { Box, styled } from '@mui/system';
import { Typography } from '@mui/material';
import { MainCard } from '@components/BaseStyles';
import { PageWrapper } from '@components/PageWrapper';

export const ProductPageWrapper = styled(PageWrapper)({
  backgroundColor: '#f9f9f9',
  padding: '78px 16px !important',
});

interface ProductMainCardProps {
  padding?: string;
  maxWidth?: string;
  minWidth?: string;
}
export const ProductMainCard = styled(MainCard)(
  ({ padding, maxWidth, minWidth }: ProductMainCardProps) => ({
    padding,
    maxWidth: maxWidth || '1200px',
    minWidth,
  }),
);

export const TopContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '12px 24px',
  alignItems: 'center',
});

export const PriceComparatorTitleContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

export const Title = styled(Typography)({
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '24px',
  letterSpacing: '0.15px',
  whiteSpace: 'nowrap',
});

export const DualCardContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '16px',
  flexDirection: 'column',
  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row',
  },
  maxWidth: '1200px',
  width: '100%',
  '& > :first-of-type': {
    flex: 1,
    minWidth: '300px',
  },
  '& > :last-of-type': {
    flex: 2,
  },
}));

export const CarouselContainer = styled('div')(({ theme }) => ({
  flex: 1,
  [theme.breakpoints.up('md')]: {
    maxWidth: '1200px',
  },
  [theme.breakpoints.up('lg')]: {
    maxWidth: '800px',
  },
}));
